import cx from 'classnames';
import { Tabs, Text } from 'platform-components';
import React from 'react';

import { SPEC_COURSE_LESSON_VIEW_TABS } from '../typings';

import './spec-course-lesson-view__tab.scss';

interface Props {
    currentTab: SPEC_COURSE_LESSON_VIEW_TABS;
    onClick: (slug: SPEC_COURSE_LESSON_VIEW_TABS) => void;
    slug: SPEC_COURSE_LESSON_VIEW_TABS;
    textId: string;
}

export const SpecCourseLessonViewTab = (props: Props) => {
    const { currentTab, onClick, slug, textId } = props;

    return (
        <Tabs.Tab
            id={slug}
            mix={cx('spec-course-lesson-view__tab', `qa_spec-course_tab-${slug}`)}
            onTabSelect={onClick}
            selected={currentTab === slug}
        >
            <Text id={textId} />
        </Tabs.Tab>
    );
};
